import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import DeliveryAILanding from "./DeliveryAILanding";

export const deliveryAIData = [
  {
    id: "delivery-ai",
    image: ["/assets/Dai_01.png"],
    tabs: {
      overview: {
        title:
          "Delivery AI is designed for teams that want better project clarity before development starts. It helps reduce ambiguity, improve collaboration, accelerate planning, and strengthen delivery governance across requirements, design, validation, and testing.",
        Subtitles:
          "AI-powered SDLC suite for faster discovery, design, and validation",
        description:
          "Delivery AI helps teams convert business ideas into clear requirements, practical designs, and validation-ready outputs. It brings business, technology, and QA teams onto the same page before development starts",
        description2:
          "The goal is simple: reduce confusion, close gaps early, and help delivery teams move faster with better control.\n Delivery AI turns business ideas into clear requirements, practical designs, and validation-ready outputs with AI agents.",
      },
      features: {
        tableData: [
          {
            feature: "AI-led discovery support",
            details:
              "Convert meeting notes, business inputs, and documents into structured delivery outputs.",
          },
          {
            feature: "Requirements and acceptance criteria",
            details:
              "Create BRD, FRD, functional requirements, non-functional requirements, and acceptance criteria.",
          },
          {
            feature: "Gap and risk detection",
            details:
              "Highlight missing details, unclear logic, assumptions, dependencies, and delivery risks early.",
          },
          {
            feature: "Design flow generation",
            details:
              "Create solution summaries, workflows, process flows, modules, APIs, integrations, and data movement views.",
          },
          {
            feature: "Validation and test readiness",
            details:
              "Generate validation rules and test scenarios so QA teams can prepare earlier.",
          },
          {
            feature: "Shared business-IT view",
            details:
              "Improve alignment between stakeholders, analysts, developers, and QA teams before build starts.",
          },
        ],
      },
      benefits: {
        tableData: [
          {
            impact: "30-50% faster documentation",
            details:
              "Reduce manual effort in preparing requirements, design summaries, and delivery documents.",
          },
          {
            impact: "25-40% fewer requirement gaps",
            details:
              "Identify missing information and unclear scope before development begins.",
          },
          {
            impact: "20-35% faster design preparation",
            details:
              "Speed up initial design, workflow, module, and integration planning.",
          },
          {
            impact: "25-45% less rework",
            details:
              "Reduce late-stage changes caused by unclear requirements or design mismatch.",
          },
          {
            impact: "30-50% faster QA readiness",
            details:
              "Help QA teams prepare validation rules and test scenarios earlier in the lifecycle.",
          },
        ],
      },
    },
  },

  {
    id: "requirement-studio",
    image: ["/assets/requirment.png"],
    tabs: {
      overview: {
        title:
          "Requirement Studio Agent converts business inputs into clear, structured, and review-ready requirements.",
        Subtitles: "Capture. Clarify. Deliver.",
        description:
          "Clear requirements, faster discovery, and better business sign-off",
        description2:
          "Requirement Studio Agent helps teams capture business needs clearly and turn them into structured requirement documents. It is useful when business inputs are scattered across meeting notes, emails, documents, and stakeholder discussions.",
      },
      features: {
        tableData: [
          {
            feature: "BRD and FRD generation",
            details:
              "Create structured business and functional requirement documents from notes, discussions, and input files.",
          },
          {
            feature: "Acceptance criteria creation",
            details:
              "Define what successful delivery should look like in a way business and QA teams can review.",
          },
          {
            feature: "Functional and non-functional capture",
            details:
              "Document features as well as performance, security, usability, compliance, and operational expectations.",
          },
          {
            feature: "Gap, assumption, and risk checks",
            details:
              "Flag missing information, open questions, dependencies, and unclear requirement areas.",
          },
          {
            feature: "Business-friendly summaries",
            details:
              "Create simple summaries that stakeholders can quickly read, validate, and approve.",
          },
        ],
      },
      benefits: {
        tableData: [
          {
            impact: "30-50% faster requirement gathering",
            details: "Accelerate discovery and documentation activities.",
          },
          {
            impact: "25-40% fewer requirement gaps",
            details: "Improve completeness before development begins.",
          },
          {
            impact: "20-35% fewer clarification cycles",
            details:
              "Reduce repeated back-and-forth between business and technology teams.",
          },
          {
            impact: "Better sign-off confidence",
            details:
              "Help stakeholders review and approve requirements with more clarity.",
          },
        ],
      },
    },
  },

  {
    id: "designer-agent",
    image: ["/assets/disgner.png"],
    tabs: {
      overview: {
        title:
          "Designer Agent converts approved requirements into practical designs, workflows, and developer-ready outputs.",
        Subtitles: "Transform requirements into developer-ready solutions",
        description:
          "From approved requirements to practical design outputs",
        description2:
          "Designer Agent helps teams convert approved requirements into practical design outputs for planning, development, and implementation. It gives developers and architects a clearer starting point before detailed build begins.",
      },
      features: {
        tableData: [
          {
            feature: "Solution design summaries",
            details:
              "Translate requirements into clear design-level understanding for business and technical teams.",
          },
          {
            feature: "Workflow and process flows",
            details:
              "Show how users, systems, business steps, and data should work together.",
          },
          {
            feature: "Screen, module, and API suggestions",
            details:
              "Suggest the building blocks needed for development planning and handoff.",
          },
          {
            feature: "System and data interaction mapping",
            details:
              "Explain how information moves across applications, integrations, and business processes.",
          },
          {
            feature: "Requirement-to-design alignment",
            details:
              "Reduce the gap between what the business requested and what technology plans to build.",
          },
        ],
      },
      benefits: {
        tableData: [
          {
            impact: "20-35% faster design preparation",
            details:
              "Reduce the time needed to prepare first-cut design documents and flows.",
          },
          {
            impact: "25-40% fewer design gaps",
            details: "Improve design completeness before development starts.",
          },
          {
            impact: "20-30% smoother developer handoff",
            details:
              "Help development teams understand scope, flows, modules, and integrations faster.",
          },
          {
            impact: "Lower delivery risk",
            details:
              "Catch missing design elements before they affect build timelines.",
          },
        ],
      },
    },
  },

  {
    id: "validatai-agent",
    image: ["/assets/validaiagent.png"],
    tabs: {
      overview: {
        title:
          "ValidatAI Agent helps teams validate requirements, designs, and rules before development starts.",
        Subtitles: "Validate before you build",
        description:
          "ValidatAI Agent helps teams review requirements, designs, and business rules before execution.",
        description2:
          "It is built to catch gaps, unclear logic, missing rules, and validation needs early in the lifecycle.",
      },
      features: {
        tableData: [
          {
            feature: "Requirement-design alignment checks",
            details:
              "Check whether design outputs are aligned with approved business requirements.",
          },
          {
            feature: "Missing rule detection",
            details:
              "Find missing rules, unclear logic, and incomplete validation conditions.",
          },
          {
            feature: "Validation rule generation",
            details:
              "Create business and data validation rules that QA and delivery teams can use.",
          },
          {
            feature: "Test scenario generation",
            details:
              "Help QA teams prepare test scenarios earlier and with better traceability.",
          },
          {
            feature: "Risk highlighting",
            details:
              "Surface delivery risks before they become costly rework or late-stage defects.",
          },
        ],
      },
      benefits: {
        tableData: [
          {
            impact: "25-45% less late-stage rework",
            details:
              "Catch gaps and mismatches before development is completed.",
          },
          {
            impact: "30-50% faster QA readiness",
            details:
              "Generate test scenarios and validation rules earlier in the lifecycle.",
          },
          {
            impact: "20-35% better defect prevention",
            details:
              "Reduce avoidable defects caused by unclear requirements or missing rules.",
          },
          {
            impact: "Stronger delivery governance",
            details:
              "Improve traceability across requirements, designs, validation, and testing.",
          },
        ],
      },
    },
  },
];

// ─────────────────────────────────────────────────────────────────────────────
// ResponsiveTable
// Same 2-col table on ALL screen sizes — no scrollbar, no overflow
// table-layout: fixed ensures columns respect their set widths
// ─────────────────────────────────────────────────────────────────────────────
const ResponsiveTable = ({
  rows,
  col1Key,
  col1Label,
  col2Key,
  col2Label,
  description,
}) => {
  return (
    <div><p className="text-2xl text-red-500 mb-8 leading-2">
                  {description}
                </p>
    <div className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden w-full">
      

      <table
        className="w-full table-fixed"
        style={{ tableLayout: "fixed" }}
      >
        <thead className="bg-gradient-to-r from-blue-600 to-purple-600 text-white">
          <tr>
            <th className="text-left px-4 sm:px-6 py-4 sm:py-5 text-sm sm:text-base  w-[38%]">
              {col1Label}
            </th>
            <th className="text-left px-4 sm:px-6 py-4 sm:py-5 text-sm sm:text-base ">
              {col2Label}
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((item, index) => (
            <tr
              key={index}
              className="border-b border-gray-100 last:border-0 hover:bg-gray-50 transition"
            >
              <td className="px-4 sm:px-6 py-4 sm:py-5 text-sm sm:text-base font-medium text-[#0f172a] align-top">
                {item[col1Key]}
              </td>
              <td className="px-4 sm:px-6 py-4 sm:py-5 text-sm sm:text-base text-gray-700 leading-6 sm:leading-7 align-top">
                {item[col2Key]}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// Tab definitions
// ─────────────────────────────────────────────────────────────────────────────
const tabs = [
  { key: "overview", label: "Overview" },
  { key: "features", label: "Key Features" },
  { key: "benefits", label: "Benefits" },
];

// ─────────────────────────────────────────────────────────────────────────────
// ProductSection
// ─────────────────────────────────────────────────────────────────────────────
const ProductSection = ({ data }) => {
  const [activeTab, setActiveTab] = useState("overview");
  const navigate = useNavigate();
  const tabData = data?.tabs?.[activeTab];

  return (
    <section className="py-16 sm:py-20 lg:py-28 bg-[#f8fafc] overflow-hidden border-b border-gray-200">

      {/* ── HEADER ── */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-10 sm:mb-14">
        <h1 className="text-2xl sm:text-2xl lg:text-3xl leading-tight text-[#0f172a]">
          {data.tabs.overview.title}
        </h1>
        <p className="mt-4 text-lg sm:text-xl text-[#2563eb]">
          {data.tabs.overview.Subtitles}
        </p>
      </div>

      {/* ── TABS ── */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10 sm:mb-14">
        <div className="grid grid-cols-3 bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`relative py-4 sm:py-5 text-xs sm:text-sm lg:text-base  transition-all duration-300 ${
                activeTab === tab.key
                  ? "text-white"
                  : "text-gray-600 hover:text-black"
              }`}
            >
              {activeTab === tab.key && (
                <motion.div
                  layoutId={`active-tab-${data.id}`}
                  className="absolute inset-0 bg-gradient-to-r from-blue-600 to-purple-600"
                />
              )}
              <span className="relative z-10">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* ── TAB CONTENT ── */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -25 }}
            transition={{ duration: 0.4 }}
          >

            {/* ── OVERVIEW ── */}
            {activeTab === "overview" && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">

                {/* Left: text */}
                <div>
                  <p className="text-base sm:text-lg leading-8 text-gray-700 mb-5">
                    {tabData.description}
                  </p>
                  <p className="text-base sm:text-lg leading-8 text-gray-700">
                    {tabData.description2}
                  </p>
                  <div className="mt-8 sm:mt-10">
                    <button
                      onClick={() => navigate("/demo")}
                      className="px-7 sm:px-8 py-3.5 sm:py-4 rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 text-white text-base sm:text-lg shadow-lg hover:scale-105 transition-all duration-300"
                    >
                      Explore Solution
                    </button>
                  </div>
                </div>

                {/* Right: image */}
                <div className="relative flex justify-center">
                  <div className="relative w-full max-w-[620px]">
                    <div className="absolute -inset-6 bg-gradient-to-r from-blue-500/20 to-purple-500/20 blur-3xl rounded-[40px]" />
                    <div className="relative bg-white rounded-[24px] sm:rounded-[32px] border border-gray-200 shadow-2xl overflow-hidden p-4 sm:p-5">
                      <img
                        src={data.image[0]}
                        alt={data.id}
                        className="w-full h-full object-contain rounded-xl sm:rounded-2xl"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* ── FEATURES ── */}
            {activeTab === "features" && (
              <ResponsiveTable
                rows={tabData.tableData}
                col1Key="feature"
                col1Label="Feature"
                col2Key="details"
                col2Label="Client-friendly Message"
              />
            )}

            {/* ── BENEFITS ── */}
            {activeTab === "benefits" && (
              <ResponsiveTable
                rows={tabData.tableData}
                col1Key="impact"
                col1Label="Expected Impact"
                col2Key="details"
                col2Label="What It Means For Client"
                description="Quantitative benefits for clients"
              />
            )}

          </motion.div>
        </AnimatePresence>
      </div>

    </section>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// DeliveryAIPage — root export
// ─────────────────────────────────────────────────────────────────────────────
const DeliveryAIPage = () => {
  return (
    <main className="bg-white">
      <DeliveryAILanding />
      {deliveryAIData.map((product) => (
        <ProductSection
          key={product.id}
          data={product}
        />
      ))}
    </main>
  );
};

export default DeliveryAIPage;